import { ArrowsDownUp } from "@phosphor-icons/react"
import clsx from "clsx"
import type React from "react"

import { ButtonIcon } from "./ButtonIcon"

type Props = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
}

export const ButtonSwitch = ({ onClick, className = "" }: Props) => {
  return (
    <div className="absolute top-[50%] left-[50%] -translate-x-2/4 -translate-y-2/4 z-10">
      <ButtonIcon
        onClick={onClick}
        className={clsx(
          "absolute top-[50%] left-[50%] -translate-x-2/4 -translate-y-2/4 z-10 flex justify-center items-center w-[26.5px] h-[26.5px] md:w-[27px] md:h-[27px] rotate-45 bg-[#2E2E2E] border-[1.5px] border-[#2E2E2E]",
          className && className
        )}
      >
        <ArrowsDownUp className="size-4 -rotate-45" weight="bold" />
      </ButtonIcon>
    </div>
  )
}
